import TimeAgo from 'react-timeago';
import Box from '@rsos/components/capstone/base/Box';
import useWhichReverseGeocodeService from '@rsos/hooks/useWhichReverseGeocodeService';
import useReverseGeocode from '@rsos/maps/interface/reverseGeocode/useReverseGeocode';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { reactTimeAgoFormatter } from '@rsos/utils/timeHelpers';
import { StyledSource } from '../../JurisdictionView/CallPane/CallPane.styles';
import { ReportAliDiscrepancyButton } from '../../discrepancies';
import NoAddress from '../NoAddress';
import Uncertainty from '../Uncertainty';
import { Loader } from '../helpers';
import { MiddleText } from '../styles/common.styles';
import { SecondaryAddressWrapper } from '../styles/locationAddress.styles';

/**
 * The secondary location component is rendered when the following conditions are true:
 * - The 911 event has a primary location (ELS)
 * - The 911 event has a secodary location (ANI/ALI) and the class of service value is WPH1 or WPH2
 * @param {Object} secondaryLocation
 * @param {Number} secondaryLocationIndex
 */
const SecondaryLocation = ({ secondaryLocation, secondaryLocationIndex }) => {
  const service = useWhichReverseGeocodeService();
  const selectedCallerID = useSelectedCallerID();

  const { isReverseGeocoding } = useReverseGeocode({
    isSecondaryLocation: true,
    location: secondaryLocation,
    locationIndex: secondaryLocationIndex,
    service,
  });

  // Extract address data to pass to discrepancy button
  const originalAddress =
    secondaryLocation?.address_single_line || secondaryLocation?.rgAddress;
  const classOfService = secondaryLocation?.class_of_service;

  return (
    <SecondaryAddressWrapper>
      <div>
        <StyledSource>
          Source: ANI/ALI ({classOfService}
          ),&nbsp;
          <TimeAgo
            date={secondaryLocation.location_time}
            formatter={reactTimeAgoFormatter}
            minPeriod={60}
            data-name="location-time-ago"
          />
        </StyledSource>
        <Box marginY="4px">
          {isReverseGeocoding ? (
            <Loader />
          ) : originalAddress ? (
            <MiddleText wrap="true">{originalAddress}</MiddleText>
          ) : (
            <NoAddress secondary />
          )}
        </Box>
        <Uncertainty
          uncertaintyRadius={secondaryLocation.uncertainty_radius}
          secondary
        />
      </div>
      <ReportAliDiscrepancyButton
        location={secondaryLocation}
        phoneNumber={selectedCallerID}
      />
    </SecondaryAddressWrapper>
  );
};

export default SecondaryLocation;
